module.exports = "<p class=\"warning1\">Supprimer cette compétence ? </p>\n<p class=\"warning2\">Les Likes associés à cette compétence seront aussi supprimés.</p>\n\n<div class=\"buttonCont\">\n  <button mat-raised-button color=\"primary\" (click)=\"closeDialog()\">Annuler</button>\n  <button mat-raised-button color=\"warn\" (click)=\"deleteExpertise()\">Supprimer</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/profile/delete-form/delete-form.component.html
// module id = ../../../../../src/app/profile/delete-form/delete-form.component.html
// module chunks = main